import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {  

  transform(items: any[], fieldName: string, value: any): any[] {

    let retVal: any[] = [];

    // return empty array if array is falsy
    if (!items) { return []; }

    if (!items.length) {
      return [];
    }

    // return the original array if the fieldname is not provided or incorrect.
    if (!fieldName) {
      return items;
    }

    // return the original array if search text is empty
    if (!value) { return items; }

    if (Array.isArray(value) && value.length > 0) {

     value.forEach(element => {
      
       let filteredArray = items.filter(x => x[fieldName] === element);

       if (filteredArray.length) {
         retVal.push(...filteredArray);       }
     });
     
    } else {
      retVal = items.filter(item => item[fieldName] === value);
    }

    // return the filtered array
    return retVal;
  }
}
